import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

interface RadioOption {
  label: string;
  value: string;
}

interface MaterialRadioButtonGroupProps {
  name: string;
  options: RadioOption[];
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  dataTestId?: string;
  disabled?: boolean;
}

const MaterialRadioButtonGroup: React.FC<MaterialRadioButtonGroupProps> = ({
  name,
  options,
  value,
  onChange,
  label,
  dataTestId,
  disabled = false,
}) => {
  return (
    <FormControl component="fieldset" data-testid={dataTestId}>
      {label && (
        <FormLabel id={`${name}-label`} component="legend">
          {label}
        </FormLabel>
      )}
      <RadioGroup
        name={name}
        value={value}
        onChange={onChange}
        row
        aria-labelledby={label ? `${name}-label` : undefined}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export { MaterialRadioButtonGroup };
